import { useEffect, useState } from "react";
export function FpsPanel() {
  const [stats, setStats] = useState({ fps: 0, p95: 0, worst: 0, slow: 0, count: 0, min: 0, max: 0 });
  useEffect(() => {
    let frame = 0, previous = 0, lastUpdate = 0;
    const history: number[] = [];
    const reset = () => { previous = 0; };
    const update = (now: number) => {
      frame = requestAnimationFrame(update);
      const delta = now - previous, hasPrevious = previous > 0;
      previous = now;
      if (document.hidden || !hasPrevious || delta <= 0) return;
      history.push(delta);
      if (history.length > 600) history.shift();
      if (now - lastUpdate < 500) return;
      lastUpdate = now;
      const sorted = [...history].sort((a, b) => a - b);
      const recent = history.slice(-60);
      const frameRates = history.slice(-120).map(ms => 1000 / ms);
      setStats({
        fps: Math.round(1000 / (recent.reduce((sum, ms) => sum + ms, 0) / recent.length)),
        p95: sorted[Math.floor((sorted.length - 1) * 0.95)] ?? 0,
        worst: sorted[sorted.length - 1] ?? 0,
        slow: history.filter(ms => ms > 16.8).length, count: history.length,
        min: Math.round(Math.min(...frameRates)), max: Math.round(Math.max(...frameRates)),
      });
    };
    document.addEventListener("visibilitychange", reset);
    frame = requestAnimationFrame(update);
    return () => { cancelAnimationFrame(frame); document.removeEventListener("visibilitychange", reset); };
  }, []);
  return <details className="fps-readout">
    <summary title="查看帧率详情">{stats.fps} FPS <span>·</span> P95 {stats.p95.toFixed(1)} ms</summary>
    <div className="fps-details">
      <span>Max frame <b>{stats.worst.toFixed(1)} ms</b></span>
      <span>&gt;16.8 ms <b>{stats.slow}/{stats.count}</b></span>
      <span>FPS range <b>{stats.min}—{stats.max}</b></span>
    </div>
  </details>;
}
